export const API = 'https://pcyc-api.appscore.digital/api/';
export const DESKTOP_APP = 'https://pcyc-desktop.appscore.digital/';
export const APP = 'https://pcyc-mobile.appscore.digital';
